module.exports = __webpack_public_path__ + "853b2291c3744c9d6e7ba69fadc735a8.png";